import React from 'react'
import { Box, styled } from '@mui/material'
import { TestIds } from '../../../../testIds'
import { Label, ProductPriceDetails } from './ProductPriceDetails'
import { ItemLabel } from '../../../../components/styled'
import { StockAvailability } from '../StockAvailability/StockAvailability'
import { useSelector } from 'react-redux'
import { selectCurrentCart } from '../../../cart/storage/cart.slice'

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '4px',
  },
}))

interface Props {
  items: Label[]
  itemNumber: string
  productId?: string
  noPriceAvailable: boolean
  orderStatusBadge?: React.ReactNode
  condensed?: boolean
  hasVariants?: boolean
}

export const ProductHeaderDetails: React.FC<Props> = ({
  items,
  itemNumber,
  noPriceAvailable,
  orderStatusBadge,
  condensed,
  productId,
  hasVariants,
}) => {
  const cart = useSelector(selectCurrentCart)

  const renderStockAvailability = React.useMemo(() => {
    if (!cart?.cartDeliveryMode) return

    return <StockAvailability productId={Number(productId)} />
  }, [cart?.cartDeliveryMode, productId, hasVariants])

  return (
    <Container>
      {orderStatusBadge}
      {!condensed && itemNumber && (
        <Box display='flex' flexDirection={'row'} gap='4px'>
          <ItemLabel variant='caption'>SKU:</ItemLabel>
          <ItemLabel variant='caption' data-testid={TestIds.feat.product.card.SKU}>
            {itemNumber}
          </ItemLabel>
        </Box>
      )}
      {renderStockAvailability}

      {!noPriceAvailable && <ProductPriceDetails items={items} />}
      {noPriceAvailable && (
        <ItemLabel variant='body2' data-testid={TestIds.feat.product.card.priceNotAvailable}>
          Price unavailable
        </ItemLabel>
      )}
    </Container>
  )
}
